import VoteFormContainer from './VoteFormContainer';

export default VoteFormContainer;
